import { c as _c } from "react-compiler-runtime";
import { useEffect, useRef, useState } from "react";
interface UseScrollRevealOptions {
  threshold?: number;
  rootMargin?: string;
  triggerOnce?: boolean;
}
export const useScrollReveal = t0 => {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    threshold: t2,
    rootMargin: t3,
    triggerOnce: t4
  } = options;
  const threshold = t2 === undefined ? 0.1 : t2;
  const rootMargin = t3 === undefined ? "0px" : t3;
  const triggerOnce = t4 === undefined ? true : t4;
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  let t5;
  let t6;
  if ($[2] !== rootMargin || $[3] !== threshold || $[4] !== triggerOnce) {
    t5 = () => {
      const element = ref.current;
      if (!element) {
        return;
      }
      const observer = new IntersectionObserver(t7 => {
        const [entry] = t7;
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (triggerOnce) {
            observer.unobserve(element);
          }
        } else {
          if (!triggerOnce) {
            setIsVisible(false);
          }
        }
      }, {
        threshold,
        rootMargin
      });
      observer.observe(element);
      return () => observer.disconnect();
    };
    t6 = [threshold, rootMargin, triggerOnce];
    $[2] = rootMargin;
    $[3] = threshold;
    $[4] = triggerOnce;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] !== isVisible) {
    t7 = {
      ref,
      isVisible
    };
    $[7] = isVisible;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default useScrollReveal;